"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFiltersContainer = exports.StyledButtonWrapper = exports.StyleFilterButton = exports.StyledInput = exports.StyledFilters = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledFilters = styled_components_1.default.div `
  width: 100%;

  & .MuiSelect-select {
    &:focus {
      background-color: transparent;
    }
  }
`;
exports.StyledInput = (0, styled_components_1.default)(ui_components_1.TextField) `
  width: 100%;

  &&& .MuiInputBase-root {
    height: ${({ theme: { spacing } }) => spacing(5.75)};
    min-height: 0px;

    .MuiInputBase-input {
      padding: ${({ theme: { spacing } }) => spacing(1.3125, 1.875)};
    }
  }
`;
exports.StyleFilterButton = (0, styled_components_1.default)(ui_components_1.Button) `
  white-space: nowrap;

  &.clear {
    color: ${({ theme }) => theme.palette.error.dark};
  }
`;
exports.StyledButtonWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing(0, 2)};
  margin: ${({ theme }) => theme.spacing(1.4, 0)};
`;
exports.StyledFiltersContainer = styled_components_1.default.div `
  background: ${({ theme }) => theme.palette.common.white};
`;
